import React from 'react';

import { CheckoutProgress } from '../../../../enums/checkout-progress.enum';

import { getEtherscanUrl } from '../../../../services/network.service';

import { centralEllipsis } from '../../../../utils/ellipsis.utils';

import CircleSpinner from '../../../circleSpinner/CircleSpinner';
import './PackageCheckoutProgressModal.scss';

type PackageCheckoutProgressModalProps = {
  checkoutProgressStep: CheckoutProgress;
  transactionHash: string;
  packageName: string;
};

const PackageCheckoutProgressModal = ({
  checkoutProgressStep,
  transactionHash,
  packageName,
}: PackageCheckoutProgressModalProps) => {
  const getProgressContent = (): React.ReactNode => {
    switch (checkoutProgressStep) {
      case CheckoutProgress.start:
        return <p>An unknown error occurred!</p>;
      case CheckoutProgress.inProgress:
        return (
          <div className="checkout-progress-modal__details">
            <p className="checkout-progress-modal__details-section">
              Your purchase of {packageName} is processing.
              <br />
              It should be confirmed on the blockchain shortly.
            </p>
            <div className="checkout-progress-modal__details-section">
              <p>Transaction ID:</p>
              <a
                target="_blank"
                rel="noreferrer"
                className="checkout-progress-modal__hash-link"
                href={getEtherscanUrl(transactionHash)}
              >
                {centralEllipsis(transactionHash)}
              </a>
            </div>
          </div>
        );
      default:
        return <></>;
    }
  };

  return (
    <div className="checkout-progress-modal">
      <div className="checkout-progress-modal__spinner">
        {checkoutProgressStep === CheckoutProgress.inProgress && <CircleSpinner size={48} />}
      </div>
      <div className="checkout-progress-modal__content">{getProgressContent()}</div>
    </div>
  );
};

export default PackageCheckoutProgressModal;
